import { createSelector } from '@reduxjs/toolkit';
import { getBirthdate, getPartnerBirthdate } from 'core/user/store/selectors';
import { MoonPhaseService } from '../services';

export const getMoonPhase = createSelector(getBirthdate, (date) =>
  MoonPhaseService.getMoonPhaseByDate(date),
);

export const getMoonSign = createSelector(getBirthdate, (date) =>
  MoonPhaseService.getMoonSign(date),
);

export const getPartnerMoonPhase = createSelector(getPartnerBirthdate, (partnerDate) => {
  return MoonPhaseService.getMoonPhaseByDate(partnerDate);
});

export const getPartnerMoonSign = createSelector(getPartnerBirthdate, (partnerDate) => {
  return MoonPhaseService.getMoonSign(partnerDate);
});
